export const TOGGLE_BUY_INTERNET_TIME_MODAL = "TOGGLE_BUY_INTERNET_TIME_MODAL";
export const TOGGLE_RESPONSE_BUY_INTERNET_TIME_MODAL =
  "TOGGLE_RESPONSE_BUY_INTERNET_TIME_MODAL";
